import PropTypes from "prop-types";
import React, { useState } from "react";

import {
  Row,
  Col,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser } from "../../store/actions";

// import images
import profile from "assets/images/zithas-logo.png";
import BackImg from "assets/images/Login-BG.jpg";
import configure from "configure";
import axios from "axios";
import { notification } from "antd";
import Loader from "components/Common/Loader";
import secureLocalStorage from "react-secure-storage";
import { FaCheckCircle } from "react-icons/fa";
import { MdError } from "react-icons/md";

const Login = (props) => {
  //meta title
  document.title = "Dashboards | Introducer Portal";
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [Loading, setloading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    api: "",
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    let hasError = false;
    const newErrors = { email: "", password: "", api: "" };

    // Validate email
    if (!email) {
      newErrors.email = "Email is required";
      hasError = true;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email format";
      hasError = true;
    }

    // Validate password
    if (!password) {
      newErrors.password = "Password is required";
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    setloading(true);
    try {
      const response = await axios.post(
        `${configure.apiUrl}/introducer/login`,
        {
          email_address: email,
          password,
        }
      );

      if (response.data.success) {
        setloading(false);
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pe-2">
                <FaCheckCircle size={20} color="green" />
              </div>
              <div>{`Login Successfull`}</div>
            </div>
          ),
        });
        secureLocalStorage.setItem("User", response.data.user);
        secureLocalStorage.setItem("Token", response.data.token);
        if (response.data.help == 1) {
          secureLocalStorage.setItem("tutorial", "skip");
        }
        navigate(`${configure.appUrl}/dashboard`)
        setErrors({ email: "", password: "", api: "" });
      } else {
        setloading(false);
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-20">
                <MdError size={20} color="red" />
              </div>
              <div>{`Credentials Not Matched`}</div>
            </div>
          ),
        });
      }
    } catch (error) {
      setloading(false);
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pe-2">
              <MdError size={20} color="red" />
            </div>
            <div>{`Something Went Wrong`}</div>
          </div>
        ),
      });
    }
  };

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col xl={9}>
              <div className="auth-full-bg pt-lg-5">
                <div className="w-100">
                  <div
                    className="bg-overlay"
                    style={{
                      backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${BackImg})`,
                      opacity: "1",
                      backgroundSize: "cover",
                    }}
                  ></div>
                  <div
                    className="d-flex h-100 flex-column"
                    style={{ position: "relative", zIndex: 999 }}
                  >
                    <div
                      className="px-4 py-5 mt-auto"
                      style={{ backgroundColor: "#2D2966" }}
                    >
                      <h2 className="text-white text-center mb-0">{`" We value every referral. You are the bridge to lasting partnerships. "`}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xl={3}>
              <div className="auth-full-page-content p-md-5 p-3">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-2 mb-md-3 mt-3">
                      <img
                        src={profile}
                        alt=""
                        //   height="18"
                        className="w-100 h-auto"
                      />
                      <h5 className="my-2 fw-bold"></h5>
                    </div>
                    <div className="my-3">
                      <div>
                        <h5 className="text-primary text-center">
                          For Our Valuable Introducers !
                        </h5>
                        <p className="text-muted text-center">
                          Sign in to continue
                        </p>
                      </div>

                      <div className="">
                        <Form
                          className="form-horizontal"
                          onSubmit={handleLogin}
                        >
                          <div className="mb-3">
                            <Label className="form-label">Email</Label>
                            <Input
                              name="email"
                              className="form-control"
                              placeholder="Enter email"
                              type="email"
                              onChange={(e) => setEmail(e.target.value)}
                              value={email}
                            />
                            {errors.email && (
                              <span className="text-danger">
                                {errors.email}
                              </span>
                            )}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Password</Label>
                            <Input
                              name="password"
                              value={password}
                              type="password"
                              placeholder="Enter Password"
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            {errors.password && (
                              <span className="text-danger">
                                {errors.password}
                              </span>
                            )}
                          </div>

                          {/* <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div> */}

                          <div className="mt-5 d-grid">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                              style={{ backgroundColor: "#2D2966", borderColor: "#2D2966" }}
                            >
                              Log In
                            </button>
                          </div>

                          {/* <div className="mt-4 text-center">
                            <Link to="/forgot-password" className="text-muted">
                              <i className="mdi mdi-lock me-1" />
                              Forgot your password?
                            </Link>
                          </div> */}
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
  router: PropTypes.shape({
    navigate: PropTypes.func,
  }),
};
